import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postOccupancyBasedPlanRate } from "../../reducer/loginReducer";
import { fallBackRoomRate } from "../../utils/bookingHelper";

const useGetMealPlanRate = (roomPriceStructure, mealPlan) => {
  const dispatch = useDispatch();

  const { hotelDetails } = useSelector((store) => store.login);
  const roomTypes = hotelDetails?.roomTypes ? hotelDetails?.roomTypes : [];

  useEffect(() => {
    getPlanRate(roomTypes, roomPriceStructure, mealPlan);
  }, [roomTypes, roomPriceStructure]);

  function findDefaultRateOfRoomType(obj, mealPlan) {
    if(obj?.meanPlanBasedPricingEnabled){
      if(obj?.mealPlanPricingDetailsMap && obj?.mealPlanPricingDetailsMap?.[mealPlan] && obj?.mealPlanPricingDetailsMap?.[mealPlan]?.basePrice){
        return obj?.mealPlanPricingDetailsMap?.[mealPlan]?.basePrice;
      }
    }
    return obj?.rate;
  }

  const getPlanRate = async (
    currentRoomTypeArray,
    currentRoomPriceStructure,
    currenMealPlan
  ) => {
    if (
      hotelDetails?.id &&
      Array.isArray(currentRoomPriceStructure) &&
      currentRoomPriceStructure?.length > 0 &&
      Array.isArray(currentRoomTypeArray) &&
      currentRoomTypeArray?.length > 0
    ) {
      const roomTypeIdByPrice = currentRoomTypeArray?.reduce((acc, obj) => {
        let rate = currentRoomPriceStructure?.find(
          (currentObj) =>
            currentObj?.type === obj?.name || currentObj?.name === obj?.name
        )?.rate;
        rate = rate ?? findDefaultRateOfRoomType(obj, mealPlan);
        rate = rate < 0 ? fallBackRoomRate(obj, mealPlan) : rate;
        rate = rate !== null && rate !== undefined ? rate : obj?.rate;

        acc[obj?._id] = +rate ?? 0;
        return acc;
      }, {});

      const payload = {
        hotelId: hotelDetails?.id,
        planOfPrice: Boolean(currenMealPlan) ? currenMealPlan : "EP",
        roomTypeIdByPrice: roomTypeIdByPrice,
        roomPriceStructure: currentRoomPriceStructure
      };

      dispatch(postOccupancyBasedPlanRate(payload));
    }
  };

  return { getPlanRate };
};

export default useGetMealPlanRate;
